import React from 'react';

import GlobeIcon from '@atlaskit/icon/core/globe';
import {
	ConfluenceIcon,
	ConfluenceDataCenterIcon,
	JiraIcon,
	JiraDataCenterIcon,
} from '@atlaskit/logo';
import { Inline, xcss } from '@atlaskit/primitives';

export const FASTSHIFT_PRODUCT_NAMES = {
	JIRA: 'JIRA',
	CONFLUENCE: 'CONFLUENCE',
} as const;

export const FASTSHIFT_PRODUCT_VARIANTS = {
	SOURCE: 'source',
	DESTINATION: 'destination',
} as const;

export type FastshiftProductVariant =
	(typeof FASTSHIFT_PRODUCT_VARIANTS)[keyof typeof FASTSHIFT_PRODUCT_VARIANTS];

type FastshiftProductConfig = Record<FastshiftProductVariant, React.ReactNode>;

const fallbackIconStyles = xcss({
	width: '32px',
	height: '32px',
	borderRadius: 'radius.medium',
	backgroundColor: 'color.background.accent.gray.subtler',
});

interface FastshiftProductIconProps {
	productName: string | null;
	variant: FastshiftProductVariant;
}

const PRODUCT_CONFIG: Record<string, FastshiftProductConfig> = {
	[FASTSHIFT_PRODUCT_NAMES.JIRA]: {
		[FASTSHIFT_PRODUCT_VARIANTS.SOURCE]: <JiraDataCenterIcon appearance="brand" size="medium" />,
		[FASTSHIFT_PRODUCT_VARIANTS.DESTINATION]: <JiraIcon appearance="brand" size="medium" />,
	},
	[FASTSHIFT_PRODUCT_NAMES.CONFLUENCE]: {
		[FASTSHIFT_PRODUCT_VARIANTS.SOURCE]: (
			<ConfluenceDataCenterIcon appearance="brand" size="medium" />
		),
		[FASTSHIFT_PRODUCT_VARIANTS.DESTINATION]: <ConfluenceIcon appearance="brand" size="medium" />,
	},
};

const FALLBACK_ICON = (
	<Inline alignBlock="center" alignInline="center" xcss={fallbackIconStyles}>
		<GlobeIcon label="" size="medium" />
	</Inline>
);

export const getFastshiftProductIcon = (
	productName: string | null,
	variant: FastshiftProductVariant,
): React.ReactNode => {
	return (productName ? PRODUCT_CONFIG[productName]?.[variant] : undefined) ?? FALLBACK_ICON;
};

export const FastshiftProductIcon = ({
	productName,
	variant,
}: FastshiftProductIconProps): React.ReactNode => {
	return getFastshiftProductIcon(productName, variant);
};
